import { QuestCategory } from 'state/vvsgotchi/models'

import DefaultQuestsList from './Default'
import GameChallengesList from './GameChallenges'

import { QuestsListProps } from './types'

const QuestsList: React.FC<QuestsListProps> = (props) => {
  const { category } = props

  switch (category) {
    case QuestCategory.GAME_CHALLENGES:
      return <GameChallengesList {...props} />

    default:
      return <DefaultQuestsList {...props} />
  }
}

export default QuestsList
